import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import OkModal from '../../../../../modules/OkModal';
import { SectionTreeTooltip } from './SectionTreeTooltip';

type TreeProps = { xrefId: string | undefined; line: boolean };
function SectionTreeMenuCopy({ xrefId, line }: TreeProps) {
  const { t } = useTranslation();

  const [displayOkModal, setDisplayOkModal] = useState(false);

  // クリップボードにコピー
  const copyToClipboard = async () => {
    await global.navigator.clipboard.writeText(xrefId !== undefined ? `#${xrefId}` : '');
    setDisplayOkModal(true);
  };

  return (
    <>
      <li onClick={() => copyToClipboard()}>
        <SectionTreeTooltip ToolTipString={xrefId !== undefined ? `#${xrefId}` : ''}>
          <i className="fa-solid fa-copy" />
        </SectionTreeTooltip>
        {t('IDコピー')}
      </li>
      {displayOkModal && (
        <OkModal onClickOk={() => setDisplayOkModal(false)}>
          <div>{t('IDをコピーしました。')}</div>
        </OkModal>
      )}
    </>
  );
}
export { SectionTreeMenuCopy };
